import { render, staticRenderFns } from "./BeneficiaryForm.vue?vue&type=template&id=2cb118f4&scoped=true&"
import script from "./BeneficiaryForm.vue?vue&type=script&lang=js&"
export * from "./BeneficiaryForm.vue?vue&type=script&lang=js&"
import style0 from "./BeneficiaryForm.vue?vue&type=style&index=0&id=2cb118f4&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2cb118f4",
  null
  
)

export default component.exports